import React from 'react';
import MoneyIcon from "@mui/icons-material/Money";

const Wallet = ({ valorCaixa }) => {
    // Garantir que o valor seja um número
    const valorNumerico = parseFloat(valorCaixa);

    // Verificar se o valor é válido antes de formatar
    const valorFormatado = isNaN(valorNumerico)
        ? 'R$ 0,00'  // Caso o valor não seja um número válido
        : valorNumerico.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

    return (
        <div className={"flex flex-col items-center"}>
            <div className="flex items-center mb-2">
                <MoneyIcon className="text-3xl text-blue-500 mr-4" />
                <h2 className="text-2xl font-semibold text-gray-200">Caixa</h2>
            </div>
            <div className="text-3xl font-bold text-blue-500">{valorFormatado}</div>
        </div>
    );
};

export default Wallet;
